import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

interface FilterItem {
  key: string;
  active: boolean;
}

@Component({
  selector: 'mb-transcript-tag-selection',
  templateUrl: './transcript-tag-selection.component.html',
  styleUrls: ['./transcript-tag-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TranscriptTagSelectionComponent {
  // public keyTranslation = {
  //   [TRANSCRIPT_ENTRY_TYPE.LINK]: 'links',
  //   [TRANSCRIPT_ENTRY_TYPE.QUOTE]: 'quotes',
  //   [TRANSCRIPT_ENTRY_TYPE.TEXT]: 'scripts',
  //   [TRANSCRIPT_ENTRY_TYPE.VIDEO]: 'videos',
  //   [TRANSCRIPT_ENTRY_TYPE.AUDIO]: 'audios',
  //   [TRANSCRIPT_ENTRY_TYPE.IMAGE]: 'images',
  //   [TRANSCRIPT_ENTRY_TYPE.DOCUMENT]: 'documents',
  // };
  public activeItems: string[] = [];
  public items: FilterItem[] = [];
  @Input() activeFilter: string[] = [];
  @Input()
  set tags(v: string[]) {
    this.items = [];
    v.forEach((label) => {
      this.items.push({
        key: label,
        active: this.activeFilter.includes(label),
      });
    });
  }

  @Output() selectionChange = new EventEmitter();

  private getActiveTags() {
    const items: string[] = [];
    this.items
      .filter((item) => item.active)
      .forEach((item) => {
        items.push(item.key);
      });
    return items;
  }

  public toggleActive(tag: FilterItem) {
    tag.active = !tag.active;
    this.activeItems = this.getActiveTags();
    this.selectionChange.emit(this.activeItems);
  }

  public resetFilters() {
    this.items.forEach((item) => {
      item.active = false;
    });
    this.activeItems = [];
    this.selectionChange.emit([]);
  }
}
